/*global Modernizr, google, currentMarker, map_markers, SVGMarker, marker_html, console, convertToDom, templater */
/*jslint browser:true */

(function() {
  'use strict';


  // When the window has finished loading create our google map below
  google.maps.event.addDomListener(window, 'load', initMap);

  function initMap() {
    // Basic options for a simple Google Map
    // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
    var mapOptions = {
  			// Map type
  			mapTypeId: 'roadmap',

        // How zoomed in you want the map to start at (always required)
        zoom: 13,
        maxZoom: 17,

        // The latitude and longitude to center the map (always required)
        center: new google.maps.LatLng(30.201, -97.788),

        // How you would like to style the map.
        // This is where you would paste any style found on Snazzy Maps.
        styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"administrative.province","elementType":"labels.text.fill","stylers":[{"color":"#054975"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#054975"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.fill","stylers":[{"color":"#d5c8b0"}]},{"featureType":"administrative.neighborhood","elementType":"labels.text.stroke","stylers":[{"weight":"2.00"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#f7f6f5"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#eeeeee"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#7b7b7b"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#a6e0f5"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#d9f5ff"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]}]
    };

    // Get the HTML DOM element that will contain your map
    // We are using a div with id="map" seen below in the <body>
    var mapElement = document.getElementById('map');

    if(mapElement) {
      google.maps.Map.prototype.setCenterWithOffset = function(latlng) {
          var map = this,
              ov = new google.maps.OverlayView();

          if(Modernizr.mq('(max-width: 750px)')) {

            ov.onAdd = function() {
              var center_offset = mapElement.offsetHeight / 4,
                  proj = this.getProjection(),
                  aPoint = proj.fromLatLngToContainerPixel(latlng);
              aPoint.y = aPoint.y+center_offset;
              map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
            };
            ov.draw = function() {};
            ov.setMap(this);
          } else {
            ov.onAdd = function() {
              var center_offset = mapElement.offsetWidth / 4,
                  proj = this.getProjection(),
                  aPoint = proj.fromLatLngToContainerPixel(latlng);
              aPoint.x = aPoint.x+center_offset;
              map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
            };
            ov.draw = function() {};
            ov.setMap(this);
          }
        };

      // Create the Google Map using our element and options defined above
      var map = new google.maps.Map(mapElement, mapOptions),
          bounds = new google.maps.LatLngBounds();

    	var image = {
        url: '/attorney_finder/images/dist/icons/map_pin.svg',
        scaledSize: new google.maps.Size(29,36)
      };

      if(map_markers) {
        map_markers.forEach((map_marker) => {
          var marker_position = new google.maps.LatLng(map_marker.lat, map_marker.lng);

          var marker_block = convertToDom(marker_html(map_marker));

          marker_block.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if(map_marker['url'] === 'show_card') {
              document.querySelector('.map-container .firm-details').classList.remove('hide');
            } else {
              var attorney_card = document.querySelector('.attorney-card[data-firm="' + map_marker.id + '"]');
              var current_card = document.querySelector('.attorney-card.show');

              if(current_card) {
                current_card.classList.remove('show');
              }

              if(attorney_card && current_card !== attorney_card) {
                window.scroll({ top: attorney_card.offsetTop - 50, left: 0, behavior: 'smooth' });
                attorney_card.classList.add('show');
              }
            }
          });

          marker_block.addEventListener('mouseover', (e) => {
            var attorney_card = document.querySelector('.attorney-card[data-firm="' + map_marker.id + '"]');
            if(attorney_card) {
              attorney_card.classList.add('hovered');
            }
          });

          marker_block.addEventListener('mouseout', (e) => {
            var attorney_card = document.querySelector('.attorney-card[data-firm="' + map_marker.id + '"]');
            if(attorney_card) {
              attorney_card.classList.remove('hovered');
            }
          });

          /* NOTE: Change size of the marker image in CSS */
          var marker = new SVGMarker({
            position: marker_position,
            map: map,
            clickable: true,
            icon: {
              size: new google.maps.Size(0, 0),
              anchor: new google.maps.Point(0, 0),
              url: '/attorney_finder/images/dist/icons/map_pin.svg', // This one is not shown so we can animate it
              class: 'SVGMarker map-marker',
              html: marker_block
            }
          });

          bounds.extend(marker_position);
        });

        map.fitBounds(bounds);

        if(map_markers[0].offcenter) {
          map.setCenterWithOffset(bounds.getCenter());
        }

        map_markers.forEach((map_marker) => {
          var attorney_card = document.querySelector('.attorney-card[data-firm="' + map_marker.id + '"]');

          if(attorney_card) {
            attorney_card.addEventListener('mouseover', (e) => {
              var this_marker = document.querySelector('.SVGMarker [data-firm="' + map_marker.id + '"]');
              if(this_marker) {
                this_marker.classList.add('hovered');
              }
            });

            attorney_card.addEventListener('mouseout', (e) => {
              var this_marker = document.querySelector('.SVGMarker [data-firm="' + map_marker.id + '"]');
              if(this_marker) {
                this_marker.classList.remove('hovered');
              }
            });


          }
        });
      }
    }
  }
}());
